import React from 'react';
import Style from './index.module.scss';
import {Breadcrumb, Button} from 'antd';
import {Link, UIMatch, useMatches, useNavigate} from 'react-router-dom';
import {BreadcrumbItemType, ItemType} from 'antd/es/breadcrumb/Breadcrumb';
import MainLayout from '../MainLayout';
import {FlexBox} from '../../FlexBox';
import Title from './Components/Title';

interface Props {
    children: React.ReactNode;
    title?: React.ReactNode;
}
const Index = ({children, title}: Props) => {
    const navigate = useNavigate();
    const matches: UIMatch<any, any>[] = useMatches();

    const BreadcrumbItem: BreadcrumbItemType[] = matches
        .filter(item => item.handle?.label)
        .map(item => {
            return {
                path: item.pathname,
                title: item.handle?.label,
            };
        });

    function itemRender(route: ItemType, params: any, routes: ItemType[]) {
        const last = routes.indexOf(route) === routes.length - 1;
        return last ? (
            <span>{route.title}</span>
        ) : (
            <Link to={route.path || '/'}>{route.title}</Link>
        );
    }

    return (
        <MainLayout.SpaceWrapper padding>
            <div className={Style.container}>
                <div className={Style.tips}>
                    <FlexBox gap="15px">
                        <Button size="small" onClick={() => navigate(-1)}>
                            返回
                        </Button>
                        <Breadcrumb
                            itemRender={itemRender}
                            items={BreadcrumbItem}
                        />
                    </FlexBox>
                    {title}
                </div>
                {children}
            </div>
        </MainLayout.SpaceWrapper>
    );
};

Index.Title = Title;
export default Index;
